<div class="create-invoice">
    <p>{{ 'CreateInvoice.title' | translate }}</p>
    
    <div class="create-invoice-form">
        <!-- <p>{{ 'CreateInvoice.form-title' | translate }}</p> -->

        <form [formGroup]="form" fxLayout="column" (ngSubmit)="onSubmit()">
            <mat-form-field appearance="fill"> 
                <mat-label>{{ 'CreateInvoice.form-agreement-no' | translate }}</mat-label>
                <mat-select formControlName="agreementNo" name="agreementTitle" disableOptionCentering >
                    <mat-option></mat-option>
                    <mat-option *ngFor="let agreementTitle of agreementTitles" [value]="agreementTitle">
                        {{ agreementTitle }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill"> 
                <mat-label>{{ 'CreateInvoice.form-agreement-vendor-debtor' | translate }}</mat-label>
                <mat-select formControlName="debtorNo" name="vendorDebtor" disableOptionCentering >
                    <mat-option></mat-option>
                    <mat-option class="not-empty-select" *ngFor="let vendorDebtor of agreementVendorsDebtorsNames" [value]="vendorDebtor">
                        {{ vendorDebtor }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>{{ 'CreateInvoice.form-invoice-date' | translate }}</mat-label>
                <input matInput [matDatepicker]="datePicker" formControlName="invoiceDate" (click)="datePicker.open()">
                <!-- <mat-hint>YYYY-MM-DD</mat-hint> -->
                <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                <mat-datepicker #datePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field >
                <mat-label>{{ 'CreateInvoice.form-invoice-no' | translate }}</mat-label>
                <input matInput formControlName="invoiceNo" placeholder="Enter Invoice No.">
            </mat-form-field>

            <mat-form-field >
                <mat-label>{{ 'CreateInvoice.form-invoice-amount-incl-VAT' | translate }}</mat-label>
                <input matInput formControlName="invoiceAmountInclVAT" placeholder="Enter Invoice Amount Including VAT">
                <mat-error>{{ 'CreateInvoice.form-invoice-amount-incl-VAT-error' | translate }}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>{{ 'CreateInvoice.form-invoice-due-date' | translate }}</mat-label>
                <input matInput [matDatepicker]="dueDatePicker" formControlName="invoiceDueDate" (click)="dueDatePicker.open()">
                <!-- <mat-hint>YYYY-MM-DD</mat-hint> -->
                <mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #dueDatePicker></mat-datepicker>
            </mat-form-field>
          
            <div class="file-upload-outer" fxFlexFill fxLayout="column">
                <div fxLayout="row">
                    <div fxLayout="column" fxLayoutAlign="center center"  class="file-upload-field" appDnd (fileDropped)="onFileDropped($event)">
                        <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowseHandler($event.target.files)" />
                        <mat-icon class="main-icon">cloud_upload</mat-icon>
                        
                        <div class="file-upload-text" fxLayout="row">
                            <mat-icon class="attach-icon">attach_file</mat-icon>
                            <p class="add-file">{{ 'Upload.add-file-title' | translate }}</p>
                            <p class="drop">{{ 'Upload.add-file-subtitle' | translate }}</p>
                        </div>
                    </div>
        
        
                    <div class="files-list" (mouseout)="removeHighlightedRow()">
                        <div fxLayout="row" class="single-file" *ngFor="let file of files; let i = index" (mouseover)="highlightRow(file)">
                            <div class="info" [ngClass] = "{'highlight-div' : file.name == selectedFile}" fxLayout="row">
                                <p class="name" [ngClass] = "{'highlight-p' : file.name == selectedFile}">{{ file?.name }}</p>
                                <p class="size" [ngClass] = "{'highlight-p' : file.name == selectedFile}">{{ formatBytes(file?.size) }}</p>
                            </div>
                            <mat-icon (click)="deleteFile(i)">close</mat-icon>
                        </div>
                    </div>
                </div>
            </div>

            <div class="send-button" fxLayout="row" fxLayoutAlign="space-between center">
                <button [ngClass]="{'disabled' : !form.valid}" [disabled]="!form.valid" mat-flat-button>{{ 'CreateInvoice.create' | translate }}</button>
            </div>
        </form>
    </div>
</div>

<app-progress-spinner  [color]="color" [mode]="mode" [value]="value" [backdropEnabled]="true" [positionGloballyCenter]="true"
 [displayProgressSpinner]="displayProgressSpinner">
</app-progress-spinner>